import { ShopGroupDetailsPage } from 'features/shop-groups';

export const AdminShopGroupDetailsPage: React.FC = () => (
  <ShopGroupDetailsPage />
);
